import React from 'react';
import PropTypes from 'prop-types';
import formatMoney from 'utils/formatters/Money';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';

class PaymentHistory extends React.Component {
  renderPaymentHeading() {
    const { t } = this.props;
    const payments = this.props.payments;
    if (payments.length === 0) {
      return t('NO_PAYMENTS');
    }
    if (payments.length === 1) {
      return t('ONE_PAYMENT');
    }
    return t('PAYMENTS_LENGTH', { paymentLength: payments.length });
  }

  renderPaymentElements() {
    const { t, currency } = this.props;
    return this.props.payments.map((payment, i) => {
      let paymentSource = t('AUTOMATIC');
      const date = moment(payment.date).format('L');
      if (payment.description && payment.description.type) {
        paymentSource = t('MANUAL');
        if (payment.description.type === 'check') paymentSource = t('CHECK');
      }
      let paymentNumber;
      if (payment.description.type === 'check') {
        paymentNumber = payment.description.check_number;
      } else {
        paymentNumber = payment.description.transaction_id;
      }

      const {
        description: { status, transaction_date },
      } = payment;
      const statusClass = 'paymentStatus ' + status;
      const transactionDate = transaction_date
        ? moment(transaction_date).format('L')
        : null;

      return (
        (<tr data-testid={`tr-783e852a-${i}`} key={i}>
          <td data-testid={`td-4abccdfc-${i}`}>{transactionDate || date}</td>
          <td data-testid={`td-33f2f45c-${i}`}>{formatMoney(payment.amount, currency)}</td>
          <td data-testid={`td-80b2735a-${i}`}>{paymentSource}</td>
          <td data-testid={`td-6f7712b1-${i}`}>{paymentNumber}</td>
          <td data-testid={`td-9b20721e-${i}`}>
            <span data-testid={`span-999d1703-${i}`} className={statusClass}>{t(sluggify(status))}</span>
          </td>
        </tr>)
      );
    });
  }

  render() {
    const payments = this.props.payments;
    const { t } = this.props;
    if (payments.length === 0) {
      return (<p data-testid="p-25cd168f" className="px-4 py-5 my-0 sm:p-6">{t('THERE_ARE_NO_PAYMENTS')}</p>);
    }

    return (
      (<div data-testid="div-acdf1b3a" className="overflow-x-auto">
        <table data-testid="table-3fa43e0e" className="default-table">
          <thead data-testid="thead-9e124809">
            <tr data-testid="tr-4faf90fd">
              <th data-testid="th-2d6ae998" className="">{t('DATE', { count: 1 })}</th>
              <th data-testid="th-cfb398d2" className="">{t('AMOUNT')}</th>
              <th data-testid="th-f7b26767" className="">{t('TYPE')}</th>
              <th data-testid="th-fca83df7" className="">{t('TRANSACTION_CHECK')} #</th>
              <th data-testid="th-c3a17070" className="">{t('STATUS')}</th>
            </tr>
          </thead>
          <tbody data-testid="tbody-a2dea422">{this.renderPaymentElements()}</tbody>
        </table>
      </div>)
    );
  }
}

PaymentHistory.propTypes = {
  payments: PropTypes.array,
};

PaymentHistory.defaultProps = {
  payments: [],
};

export default withTranslation()(PaymentHistory);
